import React from 'react';

export const IconJCB: React.FC = props => (
  <svg width="34" height="24" viewBox="0 0 34 24" fill="none" {...props}>
    <rect x="0.5" y="0.5" width="33" height="23" rx="3.5" fill="white" stroke="#D9D9D9" />
    <path
      d="M21.8489 12.2977C22.3659 12.3093 22.8859 12.2742 23.4009 12.3159C23.9224 12.4161 24.0481 13.2288 23.5847 13.4949C23.2686 13.6703 22.8931 13.5603 22.5504 13.5912H21.8489V12.2977V12.2977ZM23.6998 10.8336C23.8147 11.251 23.4238 11.6257 23.0333 11.5683H21.8489C21.8572 11.1747 21.8327 10.7474 21.8609 10.3746C22.3354 10.3883 22.8143 10.3465 23.286 10.3964C23.4887 10.4488 23.6583 10.6204 23.6998 10.8336V10.8336ZM26.5503 4.64395C26.5723 5.44105 26.5534 6.28027 26.5598 7.09354C26.5583 10.4 26.5629 13.7063 26.5572 17.0129C26.5365 18.2521 25.4696 19.3289 24.2742 19.3536C23.0776 19.3586 21.8809 19.3544 20.6841 19.3557V14.3571C21.988 14.3502 23.2926 14.3712 24.596 14.3466C25.2006 14.3075 25.8629 13.8968 25.8911 13.2119C25.9622 12.524 25.3322 12.0481 24.734 11.973C24.5041 11.9668 24.5108 11.904 24.734 11.8766C25.3046 11.7496 25.7526 11.1418 25.5847 10.533C25.4417 9.89273 24.7542 9.64492 24.1824 9.64615C23.0165 9.638 21.8503 9.64501 20.6844 9.64264C20.6919 8.70946 20.6686 7.77527 20.6969 6.84276C20.7893 5.62596 21.8829 4.6225 23.0616 4.64427C24.2246 4.64409 25.3875 4.64409 26.5503 4.64404V4.64395Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M7.50837 6.9688C7.53815 5.7316 8.60952 4.66368 9.80342 4.6456C10.9956 4.64182 12.1879 4.64506 13.3801 4.64396C13.3768 8.78339 13.3866 12.9233 13.3752 17.0625C13.3293 18.2846 12.2696 19.3322 11.0887 19.3538C9.89425 19.3583 8.69969 19.3545 7.50523 19.3557V14.1885C8.66545 14.4707 9.88213 14.5908 11.0658 14.4036C11.7733 14.2865 12.5474 13.9288 12.7869 13.1732C12.9632 12.5268 12.8639 11.8466 12.8902 11.1832V9.64266H10.8418C10.8326 10.6616 10.8606 11.6822 10.827 12.6999C10.7717 13.3254 10.17 13.7229 9.59688 13.7016C8.88614 13.7094 7.47771 13.1714 7.47771 13.1714C7.47417 11.2624 7.49833 8.87166 7.50837 6.96898V6.9688Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M14.144 10.2641C14.0362 10.2876 14.1223 9.886 14.0948 9.73365C14.1021 8.77035 14.0794 7.80601 14.1073 6.8434C14.1994 5.62146 15.3015 4.61549 16.4849 4.64409H19.9699C19.9666 8.78352 19.9763 12.9234 19.965 17.0626C19.919 18.2848 18.8592 19.3323 17.6783 19.354C16.4838 19.3586 15.2893 19.3547 14.0947 19.3559V13.6945C14.9105 14.3836 16.0193 14.4909 17.0357 14.4927C17.8019 14.4924 18.5637 14.3708 19.3078 14.1889V13.1518C18.4692 13.582 17.4835 13.8553 16.5539 13.6081C15.9054 13.4419 15.4347 12.7968 15.4452 12.1079C15.3701 11.3916 15.778 10.6352 16.4619 10.4223C17.311 10.1486 18.2364 10.3579 19.0323 10.7137C19.2028 10.8056 19.3759 10.9196 19.3077 10.6262V9.81094C17.9766 9.48492 16.56 9.36495 15.2227 9.71962C14.8356 9.83202 14.4584 10.0025 14.144 10.2642V10.2641Z"
      fill="url(#paint2_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="20.644"
        y1="11.6853"
        x2="26.5227"
        y2="11.6853"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007B40" />
        <stop offset="1" stopColor="#55B330" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="7.38023"
        y1="12.1407"
        x2="13.2838"
        y2="12.1407"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D2970" />
        <stop offset="1" stopColor="#006DBA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="14.0861"
        y1="11.8279"
        x2="19.9688"
        y2="11.8279"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2B2F" />
        <stop offset="1" stopColor="#E30138" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconJCB;
